export const setNotifSoundSetting = value => {
  localStorage.notificationsSound = `${value}`;
};

export const getNotificationSoundSetting = () => {
  let value = localStorage.notificationsSound;
  if (!['true', 'false'].includes(value)) {
    value = true;
    setNotifSoundSetting(value);
  }

  return value === 'true';
};
